export const lockSubmitBtn = () => {

    const btn = document.querySelector('#continue-btn');

    if (btn) {
        btn.classList.add('waiting-btn');
        btn.querySelector('span').innerText = 'Waiting'
    }

}

export const unlockSubmitBtn = () => {

    const btn = document.querySelector('#continue-btn');

    if (btn) {
        btn.classList.remove('waiting-btn');
        btn.querySelector('span').innerText = 'Continue'
    }

}